import { SummaryLocation } from "../containers/SendMessageScreens";
import { AccountData } from "../models/AccountData";
import { LocalPostData } from "../models/LocalPostData";
import { LocationActivityLog } from "../models/LocationActivityLog";
import { LocationData } from "../models/LocationData";
import {
  LocationReviewSummary,
  LocationReviewSummaryStatus,
} from "../models/LocationReviewSummary";
import { MediaData } from "../models/MediaData";
import { OrganizationData } from "../models/OrganizationData";
import { ReviewData } from "../models/ReviewData";

export default class DemoModeSvc {
  isDemoModeOn: boolean;
  activeKeys: Record<string, boolean>;

  static current = new DemoModeSvc();

  constructor() {
    this.isDemoModeOn = sessionStorage.getItem("isDemoModeOn") === "true";
    this.activeKeys = {};

    // TODO: Do these listeners ever need to be removed?
    this.addDemoListeners = this.addDemoListeners.bind(this);
    this.checkDemo = this.checkDemo.bind(this);
    this.toggleDemo = this.toggleDemo.bind(this);

    // TODO: Do these need to be bound?
    this.processSummaryLocation = this.processSummaryLocation.bind(this);
    this.processLocation = this.processLocation.bind(this);
    this.processOrganization = this.processOrganization.bind(this);
    this.processAccount = this.processAccount.bind(this);
    this.processLocalPost = this.processLocalPost.bind(this);
    this.processMedia = this.processMedia.bind(this);
    this.processReview = this.processReview.bind(this);
    this.processLocationReviewSummary =
      this.processLocationReviewSummary.bind(this);
  }

  addDemoListeners() {
    document.addEventListener("keydown", (event) => {
      this.activeKeys[event.key] = true;

      this.checkDemo();
    });

    document.addEventListener("keyup", (event) => {
      delete this.activeKeys[event.key];
    });
  }

  checkDemo() {
    if (
      ["d", "e", "m"].every((key) => {
        return this.activeKeys[key] === true;
      })
    ) {
      ["d", "e", "m"].forEach((key) => {
        delete this.activeKeys[key];
      });
      this.toggleDemo();
    }
  }

  toggleDemo() {
    const confirm = window.confirm(
      `デモモード${this.isDemoModeOn ? "OFF" : "ON"}にしますか？`
    );
    if (confirm) {
      this.isDemoModeOn = !this.isDemoModeOn;
      sessionStorage.setItem("isDemoModeOn", this.isDemoModeOn ? "true" : "");
      window.location.reload();
    }
  }

  processSummaryLocation(
    item: SummaryLocation,
    index?: number
  ): SummaryLocation {
    return {
      ...item,
      name: `デモ施設${index !== undefined ? index + 1 : ""}`,
    };
  }

  processLocation(item: LocationData, index?: number): LocationData {
    return {
      ...item,
      name: `デモ施設${index !== undefined ? index + 1 : ""}`,
      prefecture: "デモ県",
      city: "デモ市",
      profile: "デモ施設",
      social_profiles: {},
      ...(item.organizations
        ? { organizations: item.organizations.map(this.processOrganization) }
        : {}),
    };
  }

  processOrganization(
    item: OrganizationData,
    index?: number
  ): OrganizationData {
    return {
      ...item,
      name: `デモ団体${index !== undefined ? index + 1 : ""}`,
    };
  }

  processAccount(item: AccountData, index?: number): AccountData {
    return {
      ...item,
      name: `デモユーザー${index !== undefined ? index + 1 : ""}`,
      email: `demo@demo.com`,
      organization: item.organization
        ? this.processOrganization(item.organization)
        : undefined,
    };
  }

  processLocalPost(localPost: LocalPostData): LocalPostData {
    return {
      ...localPost,
      location_name: "デモ施設",
      summary: "デモ投稿",
      media: [],
    };
  }

  processMedia(media: MediaData): MediaData {
    return {
      ...media,
      location_name: "デモ施設",
      url: undefined,
    };
  }

  processReview(review: ReviewData): ReviewData {
    return {
      ...review,
      reviewer_name: "デモユーザー",
      processed_review: {
        review_id: "1234567890",
        comment: "Demo comment",
        gemini_reply: "デモ返信",
        translation: "デモ翻訳",
      },
    };
  }

  processLocationReviewSummary(
    item: LocationReviewSummary
  ): LocationReviewSummary {
    return {
      ...item,
      status: LocationReviewSummaryStatus.NOT_ENOUGH_REVIEWS,
    };
  }

  processActivityLogs(
    activityLogs: LocationActivityLog[]
  ): LocationActivityLog[] {
    return activityLogs.map((log) => {
      return {
        ...log,
        location: { ...log.location, name: "デモ施設" },
      };
    });
  }
}
